import { Graphics } from 'pixi.js';

// DARKNESS arena overlay — 4-rect spotlight cutout around the player position.
// Pure stateless render. Caller passes the active flag so we keep the toggle
// logic close to the wave/arena state in main.ts.
export function drawDarknessMask(g: Graphics, active: boolean, px: number, py: number, W: number, H: number): void {
  g.clear();
  if (!active) return;
  const r = 240;
  const x0 = Math.max(0, px - r), x1 = Math.min(W, px + r);
  const y0 = Math.max(0, py - r), y1 = Math.min(H, py + r);
  if (y0 > 0) g.rect(0, 0, W, y0);
  if (y1 < H) g.rect(0, y1, W, H - y1);
  if (x0 > 0) g.rect(0, y0, x0, y1 - y0);
  if (x1 < W) g.rect(x1, y0, W - x1, y1 - y0);
  g.fill({ color: 0x000000, alpha: 0.88 });
}
